import "react-app-polyfill/ie11";
import React from "react";
import ReactDOM from "react-dom";
import ReduxProvider from "./components/provider/ReduxProvider";
import App from "./components/App";

import { HelmetProvider } from 'react-helmet-async';
import { createInstance, HackleProvider } from "@hackler/react-sdk";

import './i18n';
import './static/css/temp.css';
import { getAppId } from "./utils/utilityEtc";

const hackleClient = createInstance(process.env.REACT_APP_HACKLE_KEY);
const deviceId = getAppId();

ReactDOM.render(
    <ReduxProvider>
      <HelmetProvider>
        <HackleProvider hackleClient={hackleClient} user={deviceId}>
          <App />
        </HackleProvider>
      </HelmetProvider>
    </ReduxProvider>,
  document.querySelector( '#root' )
);
